<template>
  <span class="text-primary dark:text-darkPrimaryTextColor">
    <slot />
  </span>
</template>
